import { render } from "./Now.vue?vue&type=template&id=652f6dc8&scoped=true"
import script from "./Now.vue?vue&type=script&lang=js"
export * from "./Now.vue?vue&type=script&lang=js"

import "./Now.vue?vue&type=style&index=0&id=652f6dc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652f6dc8"]])

export default __exports__